// removed by extract-text-webpack-plugin
module.exports = {"container":"_1KsauXT4e3ZoKmbveWsZ6","wrapper":"_1xSrdgtX9Y3D4kdudbZhin","scrollable":"_2j7K7vnHS2hZ_QQCnnbd6S","closeButton":"_2Jqza5CZuFx5r_AbvGW4hg"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ModalContainer/ModalContainer.mod.css
// module id = 1569
// module chunks = 0